import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { InputAdornment, IconButton } from "@mui/material";
import { resetPassword } from "../../redux/actions/userActionCreators";
import { useParams, useHistory } from "react-router-dom";
import ControlPassword from "./../../components/ControlPassword";

const ResetPassword = () => {
  useEffect(() => {
    // const resetPassword = document.getElementById('reset-password')
    const resetConfirmPassword = document.getElementById(
      "reset-confirm-password"
    );
    // resetPassword.onpaste = e => e.preventDefault()
    resetConfirmPassword.onpaste = (e) => e.preventDefault();
  }, []);
  const [showPassword, setShowPassword] = useState(false);
  const [showControl, setShowControl] = useState(false);

  const params = useParams();
  const history = useHistory();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .max(255)
        .required(t("required_field"))
        .matches(
          /^(?=.{12,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=*?!-]).*$/,
          t("password_policy")
        ),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], t("match_password"))
        .required(t("required_field")),
    }),
    // onSubmit: (values) => {
    //   dispatch(
    //     resetPassword(
    //       params.token,
    //       values.password,
    //       values.confirmPassword,
    //       history
    //     )
    //   );
    // },


    onSubmit: async (values, {  setSubmitting }) => {
  try {
    await dispatch(
      resetPassword(
        params.token,
        values.password,
        values.confirmPassword,
        history
      )
    );
  } catch (error) {
     
        const errorMessageToDisplay =
          error?.response?.data?.message_fr ||
          error?.response?.data?.message ||
          t("Une erreur est survenue. Veuillez réessayer."); 

        console.error("Password reset error:", error); 

        setSubmitting(false); 
      }
},
  });

  return (
    <>
      <Box>
        <h1>{t("reset_password")}</h1>
      </Box>
      <br></br>
      <Box component="main">
        <form onSubmit={formik.handleSubmit}>
          <div style={{ height: "130px" }}>
            <Typography variant="subtitle2">{t("password")}*</Typography>
            <TextField
              id="reset-password"
              placeholder={t("password")}
              name="password"
              variant="outlined"
              fullWidth
              error={Boolean(formik.touched.password && formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              onBlur={(e) => {
                formik.handleBlur(e);
                setShowControl(false);
              }}
              onFocus={() => setShowControl(true)}
              onChange={formik.handleChange}
              value={formik.values.password}
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      size="large"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          {showControl && (
            <div style={{ marginTop: "-25px" }}>
              <ControlPassword value={formik.values.password} />
            </div>
          )}
          <div style={{ height: "130px" }}>
            <Typography variant="subtitle2">
              {t("confirm_password")}*
            </Typography>
            <TextField
              id="reset-confirm-password"
              placeholder={t("confirm_password")}
              name="confirmPassword"
              variant="outlined"
              fullWidth
              error={Boolean(
                formik.touched.confirmPassword && formik.errors.confirmPassword
              )}
              helperText={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.confirmPassword}
              type="password"
            />
          </div>
          <Box sx={{ py: 2 }}>
            <Button
              color="secondary"
              disabled={formik.isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              {t("reset_password")}
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default ResetPassword;
